<template>
  <div class="px-10 ml-13">
    <card title="Filtros">
      <template #headerAction>
        <md-button
          class="pxd-1 m-0 m-n2"
          @click="toggleMoreFilters"
        >
          <md-icon
            class="icon-filter m-0 ml-1"
            :md-src="filterIcon"
          />
          <md-tooltip>
            {{ filterTooltip }}
          </md-tooltip>
        </md-button>
      </template>

      <md-layout class="gap-2 justify-between mt-n4">
        <SearchFieldSelector
          class="search-date-select-options"
          :selected-option="selectedDateOption"
          :text-value="dateQuery"
          :date-range-value="dateSelected"
          :default-start-date="defaultStartDate"
          :default-end-date="defaultEndDate"
          :clean-date="cleanDate"
          :limit-date="limitDate"
          :options="dateSelectOptions"
          :default-option-index="defaultOptionIndexDate"
          @updateSearchValue="setDate"
          @enterPressed="submitSearch"
        />

        <SearchFieldSelector
          class="search-multiple-text"
          :default-option-index="defaultOptionIndexText"
          :selected-option="selectedTextOption"
          :text-value="textQuery"
          :options="selectOptions"
          @update:textValue="textQuery = $event"
          @updateSearchValue="setMultipleTextSearch"
          @enterPressed="submitSearch"
        />

        <div class="gap-2 pt-2">
          <md-radio
            v-for="option in radioOptions"
            :key="option.value"
            v-model="printedRoot"
            :md-value="option.value"
            color="#7f1a54"
            class="radio"
            @input="submitSearch"
          >
            {{ option.label }}
          </md-radio>
        </div>

        <md-layout class="mt-2 gap-2 justify-end align-center">
          <md-button
            class="btn btn-primary"
            style="width: 100%; max-width: 120px"
            @click="submitSearch"
          >
            <svg-loader :src="'/static/images/icon-generate-list.svg'" />
            Listar
          </md-button>
        </md-layout>
      </md-layout>

      <transition name="dropdown">
        <div
          v-show="showMoreFilters"
          class="mt-4 mb-4"
        >
          <h3 class="results-config-modal__report-section-title">
            Mais filtros
          </h3>

          <md-layout class="gap-2 align-end px-2 mt-4">
            <div>
              <p>Selecione por tipo de cadastro:</p>
              <md-radio
                v-for="option in typeRegisterOptions"
                :key="option.value"
                v-model="integratedRoot"
                :md-value="option.value"
                @input="submitSearch"
              >
                {{ option.label }}
              </md-radio>
            </div>

            <md-layout v-if="integratedRoot">
              <FieldContainer label="Arquivos (XML)">
                <div>
                  <div v-if="filesSentStatus === 'STATUS_END'">
                    <model-list-select
                      id="comboFiles"
                      v-model="file"
                      v-validate="'required'"
                      option-text="name"
                      placeholder="Selecione um arquivo"
                      :options="getAvailableFiles()"
                      option-value="id_file"
                      :disabled="!dateSelected"
                      @input="submitSearch"
                      @keyup.enter.native="submitSearch"
                    >
                      <span slot="no-options">
                        Não foram encontrados arquivos com OS's transferidas para o período selecionado.
                      </span>
                    </model-list-select>
                  </div>
                  <div v-else>
                    <spinner class="small search__loading" />
                  </div>
                </div>
              </FieldContainer>
            </md-layout>
          </md-layout>
        </div>
      </transition>

      <div class="align-center mt-4">
        <md-layout class="flex-row gap-4">
          <button-icon
            v-for="iconItem in icons"
            :key="iconItem.label"
            :color="iconItem.color"
            :label="iconItem.label"
            :src-icon="iconItem.src"
            :value="iconItem.value"
            :hint="hintPackagingType(iconItem.value)"
            @input="e => setPackagingType(iconItem, e)"
          />
        </md-layout>
      </div>
    </card>

    <md-layout class="mt-4 gap-4 justify-end align-start">
      <slot name="actions" />
    </md-layout>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { formatDate } from '@/utils/date-utils'
import { restorePrintFilters, persistPrintFilters, arePrintFiltersEqual } from '@/utils/print-filter-session'
import {
  BATCH_PACKAGING_FROZEN_ID,
  BATCH_PACKAGING_REFRIGERATED_DRY_ID,
  BATCH_PACKAGING_REFRIGERATED_ID,
  BATCH_PACKAGING_ROOM_TEMPERATURE_ID
} from '@/enums'

import Card from '@/components/common/Card.vue'
import ButtonIcon from '@/components/common/ButtonIcon.vue'
import SearchFieldSelector from '@/components/common/SearchFieldSelectorV2.vue'
import Spinner from '@/components/common/Spinner'
import FieldContainer from '@/components/common/FieldContainer.vue'
import SelectSearch from '@/components/common/SelectSearch.vue'
import moment from 'moment'
import notify from '../../../api/notification'

export default {
  name: 'SamplesFilter',

  components: {
    Card,
    ButtonIcon,
    SearchFieldSelector,
    Spinner,
    FieldContainer,
    SelectSearch
  },

  data() {
    return {
      today: new Date(),
      cleanDate: 0,
      filtersInitialized: false,
      pendingSearch: null,
      lastAppliedFilters: null,

      typeDateSelected: null,
      dateSelected: null,
      limitDaysSamples: 20,

      patientNameRoot: null,
      codeOriginAlvaroRoot: null,
      codeOriginLisRoot: null,
      qRoot: null,
      batchLabelRoot: null,

      packagingSelected: [],
      file: null,
      filesAvailables: [],
      integratedRoot: '',
      printedRoot: '',
      showMoreFilters: false,

      dateSelectOptions: [
        {
          id: 'transferDate',
          itemValue: 'TD',
          label: 'Data da transferência',
          placeholder: 'Data da transferência',
          limitDays: 1827,
          type: 'date'
        },
        {
          id: 'collectDate',
          itemValue: 'CD',
          label: 'Data da coleta',
          placeholder: 'Data da coleta',
          limitDays: 1827,
          type: 'date'
        }
      ],
      selectOptions: [
        {
          id: 'patientName',
          label: 'Nome do Paciente',
          placeholder: 'Nome do Paciente',
          limitDays: null,
          singleDate: false,
        },
        {
          id: 'codeOriginAlvaro',
          label: 'OS Alvaro',
          placeholder: 'Os Alvaro',
          limitDays: null,
          singleDate: false,
        },
        {
          id: 'codeOriginLis',
          label: 'OS Lis',
          placeholder: 'OS Lis',
          limitDays: null,
          singleDate: false,
        },
        {
          id: 'q',
          label: 'Amostra',
          placeholder: 'Amostra',
          limitDays: null,
          singleDate: false,
        },
      ],
      radioOptions: [
        { value: '', label: 'Todas' },
        { value: true, label: 'Impressas' },
        { value: false, label: 'Não impressas' }
      ],
      typeRegisterOptions: [
        { value: '', label: 'Todos' },
        { value: false, label: 'Manual' },
        { value: true, label: 'Via importação' }
      ],

      packagingFrozenId: BATCH_PACKAGING_FROZEN_ID.toString(),
      packagingRefrigeratedId: BATCH_PACKAGING_REFRIGERATED_ID.toString(),
      packagingTemperatureId: BATCH_PACKAGING_ROOM_TEMPERATURE_ID.toString(),
      packagingRefrigeratedDryId: BATCH_PACKAGING_REFRIGERATED_DRY_ID.toString(),

      icons: [
        {
          id: BATCH_PACKAGING_FROZEN_ID.toString(),
          value: true,
          label: 'Congelado',
          color: undefined,
          src: undefined
        },
        {
          id: BATCH_PACKAGING_REFRIGERATED_ID.toString(),
          value: true,
          label: 'Refrigerado',
          color: 'background-color-royal-blue',
          src: '/static/images/icon-refrigerated.svg'
        },
        {
          id: BATCH_PACKAGING_ROOM_TEMPERATURE_ID.toString(),
          value: true,
          label: 'Ambiente',
          color: 'background-color-jaffa',
          src: '/static/images/icon-room-temperature.svg'
        },
        {
          id: BATCH_PACKAGING_REFRIGERATED_DRY_ID.toString(),
          value: true,
          label: 'Refrigerado Seco',
          color: 'background-color-shakespeare',
          src: '/static/images/icon-refrigerated-dry.svg'
        }
      ],
      selectedDateOption: null,
      dateQuery: '',
      selectedTextOption: null,
      textQuery: '',
      defaultOptionIndex: 0,
      defaultOptionIndexDate: 0,
      defaultOptionIndexText: 0,
      processingOrigin: null,
      idRecollect: null,
      isRecollectRedirect: false,
    }
  },

  computed: {
    ...mapGetters(['filesUploaded', 'filesSentStatus', 'profile', 'samplesCurrentTab']),

    defaultStartDate() {
      return this.dateSelected?.start || this.today
    },

    defaultEndDate() {
      return this.dateSelected?.end || this.today
    },

    sampleFilter() {
      const disabledRangeDate = this.idRecollect;

      return {
        startDate: disabledRangeDate ? undefined : this.startDate,
        endDate: disabledRangeDate ? undefined : this.endDate,
        dateType: disabledRangeDate ? undefined : this.typeDateSelected,
        patientName: this.patientNameRoot ? this.patientNameRoot : undefined,
        codeOriginLis: this.codeOriginLisRoot ? this.codeOriginLisRoot : undefined,
        codeOriginAlvaro: this.codeOriginAlvaroRoot ? this.codeOriginAlvaroRoot : undefined,
        q: this.qRoot ? this.qRoot : undefined,
        packagingType: this.packagingSelected.slice(),
        integrated: this.integratedRoot,
        printed: this.printedRoot,
        idFile: this.integratedRoot === true ? this.file?.id_file ?? undefined : undefined,
        processingOrigin: this.processingOrigin,
        idRecollect: this.idRecollect,
      };
    },

    filterTooltip() {
      return this.showMoreFilters ? 'Ocultar filtros' : 'Exibir mais filtros'
    },

    filterIcon() {
      return this.showMoreFilters ? '/static/images/icon-filter-minus.svg' : '/static/images/icon-filter-plus.svg'
    },

    limitDate() {
      return moment(this.today, 'DD/MM/YYYY').subtract(this.limitDaysSamples, 'days').toDate()
    },

    startDate() {
      return formatDate(this.dateSelected?.start, 4)
    },

    endDate() {
      return formatDate(this.dateSelected?.end, 4)
    }
  },

  watch: {
    '$route.query': {
      async handler(query) {
        if (!this.filtersInitialized || !/^\/print-tag\/samples\/?$/.test(this.$route.path) ||
          arePrintFiltersEqual(
            { ...query, listFilter: undefined },
            { ...this.lastAppliedFilters, listFilter: undefined }
          )) return
        this.filtersInitialized = false
        this.setInitialFilters()
        await this.$nextTick()
        if (this._isDestroyed) return
        this.filtersInitialized = true
        this.submitSearch()
      },
    },
    dateSelected(newValue) {
      if (newValue) {
        this.dateQuery = `${moment(newValue.start).format('DD/MM/YYYY')} - ${moment(newValue.end).format('DD/MM/YYYY')}`
      }
    }
  },

  created() {
    this.setInitialFilters()
  },

  async mounted() {
    await this.$nextTick()
    if (this._isDestroyed) return
    this.filtersInitialized = true
    this.submitSearch()
  },

  beforeDestroy() {
    this.filtersInitialized = false
  },

  methods: {
    ...mapActions(['selectSampleList', 'getServiceSample', 'getFilesSent']),

    setInitialFilters() {
      this.file = null
      this.typeDateSelected = 'TD'
      this.dateSelected = { start: this.today, end: this.today }
      this.packagingSelected = this.icons.map(icon => icon.id)
      this.setFiltersFromUrl()
    },

    setFiltersFromUrl() {
      const query = restorePrintFilters('samples', this.$route.query)

      if (query.startDate && query.endDate) {
        this.dateSelected = {
          start: this.parseDate(query.startDate),
          end: this.parseDate(query.endDate),
        }
      }
      this.typeDateSelected = query.dateType || 'TD'
      this.defaultOptionIndexDate = this.typeDateSelected === 'CD' ? 1 : 0
      this.selectedDateOption = this.dateSelectOptions[this.defaultOptionIndexDate]

      const textField = this.selectOptions.find(option => option.id === query.textField) ||
        this.selectOptions.find(option => query[option.id]) || this.selectOptions[0]
      this.selectedTextOption = textField
      this.defaultOptionIndexText = this.selectOptions.indexOf(textField)
      this.setMultipleTextSearch({ ...textField, query: query[textField.id] || '' })

      this.integratedRoot = this.parseBooleanFilter(query.integrated)
      this.printedRoot = this.parseBooleanFilter(query.printed)
      this.showMoreFilters = query.showMoreFilters === undefined
        ? this.integratedRoot !== '' || !!query.idFile
        : query.showMoreFilters === true || query.showMoreFilters === 'true'

      if (query.packagingType !== undefined) {
        this.packagingSelected = Array.isArray(query.packagingType)
          ? query.packagingType.map(String)
          : String(query.packagingType || '').split(',').filter(Boolean)
      }
      this.icons.forEach(icon => {
        icon.value = this.packagingSelected.includes(icon.id)
      })
      if (query.idFile) {
        this.file = this.getAvailableFiles().find(file => String(file.id_file) === String(query.idFile)) ||
          { id_file: query.idFile }
      }
      this.processingOrigin = query.processingOrigin || null
      this.idRecollect = query.idRecollect || null
      this.isRecollectRedirect = !!this.idRecollect
    },

    parseBooleanFilter(value) {
      if (value === true || value === 'true') return true
      if (value === false || value === 'false') return false
      return ''
    },

    setDate(e) {
      if (!this.filtersInitialized || !e?.date?.start || !e?.date?.end) return
      const date = { start: e.date.start, end: e.date.end }
      const type = e.itemValue || this.typeDateSelected
      const unchanged = type === this.typeDateSelected &&
        moment(date.start).isSame(this.dateSelected?.start, 'day') &&
        moment(date.end).isSame(this.dateSelected?.end, 'day')
      if (unchanged) return

      this.typeDateSelected = type
      this.selectedDateOption = this.dateSelectOptions.find(option => option.itemValue === type)
      this.dateSelected = date
      this.submitSearch()
    },

    setMultipleTextSearch(e) {
      this.selectedTextOption = e
      const query = e?.query?.trim() || ''
      this.textQuery = query

      this.patientNameRoot = ''
      this.codeOriginAlvaroRoot = ''
      this.codeOriginLisRoot = ''
      this.qRoot = ''
      this.batchLabelRoot = ''

      switch (e?.id) {
        case 'patientName':
          this.patientNameRoot = query
          break
        case 'codeOriginAlvaro':
          this.codeOriginAlvaroRoot = query
          break
        case 'codeOriginLis':
          this.codeOriginLisRoot = query
          break
        case 'q':
          this.qRoot = query
          break
      }
    },

    setPackagingType(icon, value) {
      const { id } = icon
      const allSelected = this.icons.every(item => item.value)

      if (allSelected) {
        this.deselectAllExcept(id)
      } else {
        this.toggleSelection(icon, value)
      }

      this.submitSearch()
    },

    deselectAllExcept(id) {
      this.icons.forEach(item => {
        item.value = item.id === id
      })
      this.packagingSelected = [id]
    },

    toggleSelection(icon, value) {
      icon.value = value
      const index = this.packagingSelected.indexOf(icon.id)

      if (index === -1) {
        this.packagingSelected.push(icon.id)
      } else {
        this.packagingSelected.splice(index, 1)
      }
    },

    submitSearch() {
      if (!this.filtersInitialized) return Promise.resolve()
      if (!this.pendingSearch) {
        this.pendingSearch = new Promise(resolve => setTimeout(resolve, 0)).then(() => {
          this.pendingSearch = null
          return this.executeSearch()
        })
      }
      return this.pendingSearch
    },

    async executeSearch() {
      if (!this.filtersInitialized) return
      this.lastAppliedFilters = this.getCurrentFilters()
      await persistPrintFilters(this, 'samples', this.lastAppliedFilters)
      if (!this.filtersInitialized) return
      if (!this.idRecollect && !this.isValidDateRange()) {
        notify({ title: 'AVISO:', message: 'Selecione um período válido de até 21 dias.' })
        return
      }
      this.selectSampleList(this.sampleFilter)
      await this.getServiceSample()
      await this.getFiles()
    },

    isValidDateRange() {
      const start = moment(this.dateSelected?.start)
      const end = moment(this.dateSelected?.end)
      const diffDays = end.diff(start, 'days')
      return !!this.dateSelected?.start && !!this.dateSelected?.end &&
        start.isValid() && end.isValid() && diffDays >= 0 && diffDays <= 21
    },

    async getFiles() {
      const params = {
        startDate: this.startDate,
        endDate: this.endDate,
        idLaboratory: this.profile?.id_laboratory,
        stateList: 'TRANSMITTED'
      }
      await this.getFilesSent(params)
      this.filesAvailables = this.getAvailableFiles()
      if (this.file) {
        this.file = this.filesAvailables.find(file => String(file.id_file) === String(this.file.id_file)) || this.file
      }
    },

    getAvailableFiles() {
      return (this.filesUploaded || []).map(file => ({
        ...file,
        label: file.name,
        value: file.id_file,
      }))
    },

    toggleMoreFilters() {
      this.showMoreFilters = !this.showMoreFilters
      this.lastAppliedFilters = {
        ...restorePrintFilters('samples', this.$route.query),
        showMoreFilters: this.showMoreFilters,
      }
      persistPrintFilters(this, 'samples', this.lastAppliedFilters)
    },

    hintPackagingType(value) {
      const packagingSelected = this.packagingSelected
      const hintSelect = 'Selecione para filtrar uma ou mais formas de acondicionamento'
      const hintDeselect = 'Clique para remover filtro'

      if (packagingSelected?.length === 4 && value) return hintSelect

      if (value) return hintDeselect

      return hintSelect
    },

    parseDate(dateStr) {
      return moment(dateStr, 'DD/MM/YYYY', true).toDate()
    },

    getCurrentFilters() {
      return {
        listFilter: restorePrintFilters('samples', this.$route.query).listFilter || '',
        tab: this.samplesCurrentTab,
        startDate: this.startDate,
        endDate: this.endDate,
        dateType: this.typeDateSelected,
        packagingType: this.packagingSelected.join(','),
        integrated: this.integratedRoot,
        printed: this.printedRoot,
        patientName: this.patientNameRoot || '',
        codeOriginAlvaro: this.codeOriginAlvaroRoot || '',
        codeOriginLis: this.codeOriginLisRoot || '',
        q: this.qRoot || '',
        textField: this.selectedTextOption?.id || this.selectOptions[this.defaultOptionIndexText].id,
        idFile: this.file?.id_file || '',
        showMoreFilters: this.showMoreFilters,
        processingOrigin: this.processingOrigin || '',
        idRecollect: this.idRecollect || '',
      }
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.md-theme-default.md-radio .md-radio-container:after) {
  background-color: #7f1a54 !important;
}

:deep(.md-theme-default.md-radio.md-checked .md-radio-container) {
  border-color: #7f1a54 !important;
}

:deep(.card-form__container) {
  padding-top: 8px !important;
}

.icon-filter {
  color: #7f1a54;
}

.search-date-select-options {
  max-width: 30%;
}

.search-multiple-text {
  max-width: calc(100% - 450px - 30%);
}

.container-file {
  width: 40%;
}

@media (max-width: 1600px) {

  .search-date-select-options,
  .search-multiple-text {
    max-width: 30%;
  }
}

@media (max-width: 1281px) {

  .search-date-select-options,
  .search-multiple-text {
    width: 49%;
    max-width: 49%;
  }
}
</style>
